import { PlannerApi } from '../planner.api';
import type { ApiResponse, PlannerTaskRelation } from '@vision/ui/interfaces';
import type { PlannerTaskRelationCreateArgs, PlannerTaskRelationDeleteArgs } from './task-relations.api.types';
import { buildCreateTaskRelationRequest, buildDeleteTaskRelationRequest } from './task-relations.routes';
import { fromApiPlannerTaskRelationResponse } from './task-relations.mappers';

export const PlannerTaskRelationEndpoints = PlannerApi.injectEndpoints({
  endpoints: (builder) => ({
    createTaskRelation: builder.mutation<ApiResponse<PlannerTaskRelation>, PlannerTaskRelationCreateArgs>({
      transformResponse: fromApiPlannerTaskRelationResponse,
      query: buildCreateTaskRelationRequest,
    }),
    deleteTaskRelation: builder.mutation<void, PlannerTaskRelationDeleteArgs>({
      query: buildDeleteTaskRelationRequest,
    }),
  }),
});

export const { useCreateTaskRelationMutation, useDeleteTaskRelationMutation } = PlannerTaskRelationEndpoints;
